import React from 'react';
import styled from  'styled-components';

const Container = styled.div`
  border-bottom-style: none;
  border-color: #383838;
  border-left-style: none;
  border-radius: 0px;
  border-right-style: none;
  border-top-style:none;
  border-width: 1px;
`;

const SectionComponent = styled.section`
  background: #383838 !important;
  border-bottom-style: none;
  border-color: #000000;
  border-left-style: none;
  border-radius: 0px;
  border-right-style: none;
  border-top-style: none;
  border-width: 1px;
`

const Row = styled.div`
  min-height: 50px;
  max-width:960px;
  margin-left:auto;
  margin-right:auto;  

`

const Column = styled.div`
  flex: 12 0 0;
  background-color: transparent;
  justify-content: center;
  padding-top: 0px;
  padding-right: 10px;
  padding-bottom: 0px;
  padding-left: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const ContainerText = styled.div`
  border-bottom-style: none;
  border-color: #000000;
  border-left-style: none;
  border-radius: 0px;
  border-right-style: none;
  border-top-style: none;
  border-width: 1px;
  min-height: auto0px;
  max-width: 928px;
  margin-top: 40px;
  margin-bottom: 40px;
  align-self: center;
  width: 100%;
  word-break: break-word;
`

const Title = styled.h3`
  text-align: center;
  
  &::after{
    content: " ";
    display: block;
    width: 10%;
    height: 2px;
    margin: 15px auto;
    border: 0;
    background: none;
    transition: all .4s;
  }
`

const RowImage = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr ;
  min-height: 50px;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
`

const ColumnImage = styled.div`
  flex: 3 0 0 !important;

  & div{
    margin:10px auto;
    background-color: transparent;
    justify-content: flex-end !important;
    padding-top: 0px;
    padding-right: 10px;
    padding-bottom: 0px;
    padding-left: 10px;
    display: flex !important;
    flex-direction: column !important;
  }
`

const ContainerImage = styled.div`
  border-bottom-style: none;
  border-color: #000000;
  border-left-style: none;
  border-radius: 0px;
  border-right-style: none;
  border-top-style: none;
  border-width: 1px;
`

const Section = () => (
  <>
    <Container>
      <SectionComponent>
        <Row>
          <Column>
              <ContainerText>
                <Title>
                  <strong 
                    style={{
                      fontSize:32, 
                      color:"#FFF", 
                      fontFamily:'Ubuntu, sans-serif'
                    }}>
                    Empresas que apoiam esta iniciativa:
                  </strong>
                </Title>
              </ContainerText>
          </Column>
        </Row>
      </SectionComponent>

      <SectionComponent>
        <RowImage>
          <ColumnImage>
            <div>
              <ContainerImage>
                <img 
                  style={{width:"153px", height:"67px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/nuererprj.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"126px", height:"74px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/nubeep.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"86px", height:"97px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/nupieepro.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"101px", height:"101px"}}  
                  src='https://files.voitto.com.br/parceiros-logo/nuseep.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img
                  style={{width:"99px", height:"97px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/nucaeep.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{height:'100px', width:'90px'}} 
                  src='https://files.voitto.com.br/parceiros-logo/nupreep.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{height:'99px', width:'97px'}} 
                  src='https://files.voitto.com.br/parceiros-logo/nupreenp.png' alt=''
                />
              </ContainerImage>
            </div>
          </ColumnImage>

          <ColumnImage>
            <div>
              <ContainerImage>
                <img 
                  style={{width:"67px", height:"83px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/aberpro.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"130px", height:"31px"}}
                  src='https://files.voitto.com.br/parceiros-logo/masci.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"110px", height:"44px"}}
                  src='https://files.voitto.com.br/parceiros-logo/pulso.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"124px", height:"38px"}}
                  src='https://files.voitto.com.br/parceiros-logo/campe.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"144px", height:"74px"}}
                  src='https://files.voitto.com.br/parceiros-logo/maximaconsultoria.png'
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"136px", height:"24px"}}
                  src='https://files.voitto.com.br/parceiros-logo/produp.png' alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"107px", height:"76px"}}
                  src='https://files.voitto.com.br/parceiros-logo/porte.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"156px", height:"53px"}}
                  src='https://files.voitto.com.br/parceiros-logo/projectjr.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{height:'75.23px', width:'56px'}}
                  src='https://files.voitto.com.br/parceiros-logo/triello.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <a href='https://www.bertholdo.com.br/' target="_blank">
                  <img 
                    style={{height:'50px'}}
                    src='https://files.voitto.com.br/parceiros-logo/bertholdo.png' 
                    alt=''
                  />
                 </a>
              </ContainerImage>

              <ContainerImage>
                <a href='https://www.acoplastbrasil.com.br/' target="_blank">
                  <img 
                    style={{height:'50px'}}
                    src='https://files.voitto.com.br/parceiros-logo/Acoplast.png' 
                    alt=''
                  />
                 </a>
              </ContainerImage>

              <ContainerImage>
                <a href='https://capitalsocial.cnt.br/' target="_blank">
                  <img 
                    style={{height:'90px', marginTop:'-48px'}}
                    src='https://files.voitto.com.br/parceiros-logo/Artboard.png' 
                    alt=''
                  />
                 </a>
              </ContainerImage>
            </div>
          </ColumnImage>

          <ColumnImage>        
            <div>
              <ContainerImage>
                <img 
                  style={{width:"220px", height:"48px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/estagioonline.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"156px", height:"62px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/connep.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"158px", height:"63px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/engsemfronteiras.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"133px", height:"34px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/creatjrba.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"146px", height:"42px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/creajrmg.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img style={{width:"146px", height:"42px"}} src='https://files.voitto.com.br/parceiros-logo/creajrro.png' alt=''/>
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"146px", height:"42px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/creajrgo.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"123px", height:"76px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/acrejr.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"97px", height:"64px"}} 
                  src='https://files.voitto.com.br/parceiros-logo/faroluniversitario.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <a 
                  href="https://www.pontotel.com.br/?utm_source=cursosquarentena&utm_medium=voitto&utm_campaign=parceiro"
                  target="_blank"
                >
                  <img 
                    style={{height:'50px', marginTop:'20px'}}
                    src='https://files.voitto.com.br/parceiros-logo/pontotel.png' 
                    alt=''
                  />
                 </a>
              </ContainerImage>

              <ContainerImage>
                <a 
                  href="https://www.acoplastbrasil.com.br/"
                  target="_blank"
                >
                  <img 
                    style={{height:'50px', marginTop:'20px'}}
                    src='https://files.voitto.com.br/parceiros-logo/acoplast.png' 
                    alt=''
                  />
                 </a>
              </ContainerImage>
            </div>
          </ColumnImage>

          <ColumnImage>
            <div>
              <ContainerImage>
                <a href='https://keruak.com.br/' target="_blank">
                  <img 
                    style={{height:'41px', width:'161px'}}
                    src='https://files.voitto.com.br/parceiros-logo/logo-branco-keruak-945x265.png' 
                    alt=''
                  />
                </a>
              </ContainerImage>

              <ContainerImage>
                <a href="https://www.egestor.com.br/" target="_blank">
                  <img 
                    style={{height:'55px', width:'180px'}}
                    src='https://files.voitto.com.br/parceiros-logo/egestor.png' 
                    alt=''
                  />
                </a>
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{height:'85px', width:'180px'}}
                  src='https://files.voitto.com.br/parceiros-logo/pro.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <a href='https://gaea.com.br/' target="_blank">
                  <img 
                    style={{height:'35px', width:'158px'}} 
                    src='https://files.voitto.com.br/parceiros-logo/gaea.png' 
                    alt=''
                  />
                </a>
              </ContainerImage>

              <ContainerImage>
                <a href='https://www.solides.com.br/' target="_blank">
                  <img 
                    style={{height:'65px', width:'180px'}} 
                    src='https://files.voitto.com.br/parceiros-logo/Solides.png' 
                    alt=''
                  />
                </a>
              </ContainerImage>

              <ContainerImage>
                <a href='https://pluga.co/' target="_blank">
                  <img 
                    style={{height:'36px', width:'175px'}} 
                    src='https://files.voitto.com.br/parceiros-logo/logo-pluga-branco.png' 
                    alt=''
                  />
                </a>
              </ContainerImage>

              <ContainerImage>
                <a href='https://startupi.com.br/' target="_blank">
                  <img  
                    style={{height:'45px', width:'180px'}} 
                    src='https://files.voitto.com.br/parceiros-logo/startupi.png' 
                    alt=''
                  />
                </a>
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{width:"220px", height:"35px"}}
                  src='https://files.voitto.com.br/parceiros-logo/grupoimpacta.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <img 
                  style={{height:'67', width:'77px'}}
                  src='https://files.voitto.com.br/parceiros-logo/escudoicon.png' 
                  alt=''
                />
              </ContainerImage>

              <ContainerImage>
                <a href="https://www.convenia.com.br/" target="_blank">
                  <img 
                    style={{height:'77', width:'150px'}}
                    src='http://files.voitto.com.br/parceiros-logo/convenia.png' 
                    alt=''
                  />
                </a>
              </ContainerImage>
            </div>
          </ColumnImage>         
        </RowImage>
      </SectionComponent>
    </Container>
  </>  
)

export default Section;
